import type { FaireProductEntity } from "../../entity_types/product";

export const p_m8c65uwxfq: FaireProductEntity = {
  token: "p_m8c65uwxfq",
  type: "product",
  name: "Gold Filled Mixed Drop cubic zirconia Heart Dainty Chain Necklace Chain, sku#LS17",
  brandToken: "b_4f46qpq5wu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/995e3ff9f877db67fa2f0b33692279f6a73fa9b1f00ceedf17261e88ad171191.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e8e82c1d61b2a4902b3f9f0694c33fff0fe4e854c21fe5881fd021f018ee45bb.jpeg",
    "https://cdn.faire.com/fastly/7c2843a1eefa14f08bbec21654a1afed9fb5408e604fc1558cd22c4e2925b4f7.jpeg",
    "https://cdn.faire.com/fastly/b4c9fbd780e0edf61a531061a441bd272030368aa6cc9a3aa74fc481a9a4ed4d.jpeg",
  ],
  priceDollars: 19.26,
  description:
    "\nMaterial: cubic zirconia, Gold Filled\n\nSale by Yard or By Necklace\n\nNecklace: 15inch with 2inch extension. \n",
  tags: [],
  msrpDollars: 38.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:02.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
